const Name = ({
    name
}) => {
  return <span className="relative z-10">{name}</span>
}

export default Name
